// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"4e24b801","86":"fe60bab1","722":"80f31142"}[chunkId] + ".chunk.js";
};